import api, { unwrap } from './client';

/* Quoi de neuf — les nouveautés livrées, rédigées par l'exploitant dans
   Chantier › Nouveautés. Lecture ouverte à tout connecté ; écriture admin. */

export const listNews = (module, limit) => {
  const params = new URLSearchParams();
  if (module) params.set('module', module);
  if (limit) params.set('limit', String(limit));
  const qs = params.toString() ? `?${params}` : '';
  return unwrap(api.get(`/news${qs}`));
};

export const createNews = (payload) => unwrap(api.post('/news', payload));
export const updateNews = (id, payload) => unwrap(api.patch(`/news/${id}`, payload));
export const deleteNews = (id) => unwrap(api.delete(`/news/${id}`));
